import React from 'react';

import {
  ChecklistContainer,
  ChecklistItem,
  ChecklistList,
  ChecklistTitle,
  CheckmarkWrapper
} from './styledComponents';

interface ChecklistWithTitleProps {
  title?: string;
  items?: string;
}

const ChecklistWithTitle: React.FC<ChecklistWithTitleProps> = ({
  title,
  items
}) => {
  return (
    <ChecklistContainer className="checklist-with-title">
      {title && (
        <ChecklistTitle className="checklist-title">{title}</ChecklistTitle>
      )}
      <ChecklistList className="checklist-list">{items}</ChecklistList>
    </ChecklistContainer>
  );
};

export default ChecklistWithTitle;
